module.exports = __webpack_public_path__ + "static/media/kareem.10c988e9.jpg";